/*
 * Gift note: adds/removes the €2,95 card product and stores the customer's
 * message as a line item property so it travels to the order.
 *
 * The cart drawer replaces its own innerHTML on every render, so this element
 * re-connects each time and must not hold state outside itself.
 */
class SNGiftNote extends HTMLElement {
  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.handle = this.dataset.handle;
    this.check = this.querySelector('.sn-gift-note__check');
    this.panel = this.querySelector('.sn-gift-note__panel');
    this.text = this.querySelector('.sn-gift-note__text');
    this.count = this.querySelector('[data-count]');
    this.status = this.querySelector('[data-status]');
    this.saveBtn = this.querySelector('[data-save]');

    if (!this.check) return;

    this.check.addEventListener('change', () => this.onToggle());
    this.text.addEventListener('input', () => this.onType());
    this.saveBtn.addEventListener('click', () => this.save());
    this.onType();
  }

  onType() {
    const n = this.text.value.length;
    this.count.textContent = n + '/200';
  }

  say(msg, tone) {
    this.status.textContent = msg || '';
    this.status.dataset.tone = tone || '';
  }

  busy(on) {
    this.toggleAttribute('data-busy', !!on);
    if (this.saveBtn) this.saveBtn.disabled = !!on;
    if (this.check) this.check.disabled = !!on;
  }

  onToggle() {
    if (this.check.checked) {
      this.panel.hidden = false;
      this.text.focus();
      this.add();
    } else {
      this.panel.hidden = true;
      this.remove_();
    }
  }

  /* Adding goes through the shared cart helper so the drawer re-renders and the
     header bubble stays in step. */
  add() {
    this.busy(true);
    const items = [
      {
        id: Number(this.variantId),
        quantity: 1,
        properties: { Boodschap: this.text.value.trim() || '—' },
      },
    ];

    const done = () => {
      this.busy(false);
      this.say('Kaartje toegevoegd.', 'ok');
    };

    if (window.SNCart && typeof window.SNCart.add === 'function') {
      window.SNCart.add(items, { openDrawer: false }).then(done).catch(() => {
        this.busy(false);
        this.say('Kon het kaartje niet toevoegen.', 'err');
      });
      return;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(done)
      .catch(() => this.say('Kon het kaartje niet toevoegen.', 'err'));
  }

  /* Named remove_ so it does not shadow HTMLElement.prototype.remove. */
  remove_() {
    this.busy(true);
    this.changeByHandle(0)
      .then(() => {
        this.busy(false);
        this.say('');
      })
      .catch(() => {
        this.busy(false);
        this.say('Kon het kaartje niet verwijderen.', 'err');
      });
  }

  save() {
    if (!this.check.checked) return;
    this.busy(true);
    // A line item's properties cannot be patched in place: drop the line and
    // re-add it with the new message.
    this.changeByHandle(0)
      .then(() => this.add())
      .then(() => this.say('Boodschap opgeslagen.', 'ok'))
      .catch(() => {
        this.busy(false);
        this.say('Opslaan mislukt.', 'err');
      });
  }

  changeByHandle(quantity) {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const idx = cart.items.findIndex((i) => i.handle === this.handle);
        if (idx < 0) return null;
        return fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: idx + 1, quantity: quantity }),
        }).then((r) => r.json());
      })
      .then((cart) => {
        if (cart) this.refreshDrawer();
        return cart;
      });
  }

  /* Re-render the drawer so the subtotal and line list reflect the change. */
  refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then((r) => r.json())
      .then((sections) => drawer.renderContents({ sections: sections }))
      .catch(() => {});
  }
}

if (!customElements.get('sn-gift-note')) {
  customElements.define('sn-gift-note', SNGiftNote);
}
